import clsx from 'clsx';
import { FC, useEffect, useRef } from 'react';
// import { useIntl } from 'react-intl';

//contants
import { KEY } from 'Data/constants';

//styles
import styles from './footer-drop-down-btn.module.scss';
import { useIntl } from 'react-intl';

interface IFooterDropDownBtnProps {
  isDropDownOpen: boolean;
  setIsDropDownOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const FooterDropDownBtn: FC<IFooterDropDownBtnProps> = ({ isDropDownOpen, setIsDropDownOpen }) => {
  const buttonNode = useRef<HTMLButtonElement>(null);
  const { formatMessage } = useIntl();

  const handleKeyboardEvents = (event: KeyboardEvent) => {
    const key = event.key;
    // Prevent default if one of the following keys are pressed: space, arrow up, arrow down
    if (([KEY.ARROW_RIGHT, KEY.ARROW_LEFT] as string[]).indexOf(key) > -1) {
      event.preventDefault();
    }
    switch (key) {
      case KEY.ARROW_RIGHT:
        setIsDropDownOpen(true);
        break;
      case KEY.ARROW_LEFT:
        setIsDropDownOpen(false);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const ref = buttonNode.current;
    ref?.addEventListener('keydown', handleKeyboardEvents);
    return () => {
      ref?.removeEventListener('keydown', handleKeyboardEvents);
    };
  });

  return (
    <button
      ref={buttonNode}
      onClick={() => setIsDropDownOpen((isExpanded) => !isExpanded)}
      className={clsx(styles.footerDropDownBtn, isDropDownOpen && styles.flipButton)}
      aria-expanded={isDropDownOpen}
      aria-label={formatMessage({ id: 'btnIcon' })}
    />
  );
};

// FooterDropDownBtn.defaultProps = {
//   setIsDropDownOpen: null,
//   isDropDownOpen: false,
// };

export default FooterDropDownBtn;
